import { QuizSession } from '../types';
import { ENDPOINTS } from '../consts/endpoints';
import { AbstractApi } from '../../abstract-api';
import { UserType, DEFAULT_PARAMS } from '../../user-api';
import {
  SkillGroup,
  SkillGroupParams,
  SkillCategoryParams,
  SkillCategoryAssessment,
  SkillCategoryAssessmentParams,
  SkillCategoryAssessmentResponse,
  SkillCategory as SkillCategoryType,
} from '../types';

export class SkillCategoryApi extends AbstractApi {
  async getSkillCategoryByRoleDepartment(roleDepartmentId: string): Promise<SkillCategoryType[]> {
    const axios = await this.axios();
    const params: SkillCategoryParams = {
      roleDepartmentId,
    };
    const { data } = await axios.get<{ skillCategories: SkillCategoryType[] }>(
      ENDPOINTS.LEARNING.SKILL.CATEGORY,
      {
        params,
      }
    );
    return data.skillCategories;
  }

  async getSkillCategoryById(skillCategoryId: string): Promise<SkillGroup> {
    const axios = await this.axios();

    const params: SkillGroupParams = {
      skillCategoryId,
    };
    const { data } = await axios.get<SkillGroup>(ENDPOINTS.LEARNING.SKILL.GROUP, {
      params,
    });

    return data;
  }

  async postSkillCategoryAssessment(
    assessment: SkillCategoryAssessment,
    userType?: UserType,
    department?: string,
    roleDepartmentId?: string
  ): Promise<QuizSession> {
    const axios = await this.axios();
    const params: SkillCategoryAssessmentParams = {
      type: userType ?? DEFAULT_PARAMS.USER_TYPE,
      department: department ?? DEFAULT_PARAMS.DEPARTMENT,
      roleDepartmentId: roleDepartmentId ?? DEFAULT_PARAMS.ROLE_DEPARTMENT_ID,
    };
    const { data } = await axios.post<SkillCategoryAssessmentResponse>(
      ENDPOINTS.LEARNING.SKILL.ASSESSMENT,
      { ...assessment },
      { params }
    );
    return data.session;
  }
}
